import { ref, watch } from 'vue';
import AiOperations from '@/domain/model/ai/AiOperations';
import EventUtils from '@/utils/EventUtils.js';
import AiPrompt from '@/domain/model/ai/prompt/AiPrompt';
import { uuid } from 'vue-uuid';

export function createAiChatServiceDMZ(store) {
  const pendingRequests = ref([]);
  let watcherAuthConnected = null;

  // Setup watchers if they don't exist
  if (!watcherAuthConnected) {
    watcherAuthConnected = watch(() => store.getters.auth_connected, (isConnected) => {
      if (isConnected && pendingRequests.value.length > 0) {
        const client = store.getters.auth_client;
        if (client && client.socket && client.socket.connection) {
          pendingRequests.value.forEach(req => {
            EventUtils.Send.event(client.socket.connection, req);
          });
          pendingRequests.value = [];
        }
      }
    });
  }

  return {
    async sendPrompt(params, onMessageReceived, onError, onFinished) {
      const event = AiOperations.Prompt.Operation(params);
      const requestId = uuid.v1();
      event['@rid'] = requestId;
      event['timeZone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
      event['maker'] = window.navigator.userAgent;
      
      const client = store.getters.auth_client;
      if (client) {
        event['deviceId'] = client.deviceId;
        event['version'] = client.version;
      }

      if (store.getters.auth_connected) {
        EventUtils.Send.event(client.socket.connection, event);
      } else {
        pendingRequests.value.push(event);
        store.dispatch('connectSocket');
      }

      // Temporarily watch the socket messages for this specific response
      const unwatch = watch(() => store.getters.auth_socket_message, (newMsg) => {
        if (!newMsg) return;
        
        if (newMsg.eventName === AiOperations.Prompt.Names.Notification) {
          if (newMsg.status === 'error') {
            if (onError) onError('Ouch, that question hurt my brain. ' + (newMsg.hint || ''));
          } else {
            const payload = newMsg.Payload || {};
            const promptBlob = payload[AiPrompt.MODEL_NAME] || {};
            const responseText = payload.response || '';
            
            if (onMessageReceived) {
              onMessageReceived({
                id: promptBlob['@rid'] || '',
                content: responseText,
              });
            }
          }
          if (onFinished) onFinished();
          unwatch(); // Stop listening after we get the response
        }
      });
    },

    async savePrompt(messageId, likedValue) {
      const params = {
        AiPrompt: messageId,
        liked: likedValue,
      };
      const event = AiOperations.Save.Operation(params);
      event['@rid'] = uuid.v1();
      event['timeZone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
      event['maker'] = window.navigator.userAgent;
      
      const client = store.getters.auth_client;
      if (client) {
        event['deviceId'] = client.deviceId;
        event['version'] = client.version;
      }

      if (store.getters.auth_connected) {
        EventUtils.Send.event(client.socket.connection, event);
      } else {
        pendingRequests.value.push(event);
        store.dispatch('connectSocket');
      }
    }
  };
}
